import { z } from 'zod';

export const LogoFileMimeTypesArr = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
  'image/svg+xml',
] as const;

export const LogoFileMimeType = z.enum(LogoFileMimeTypesArr);
export type LogoFileMimeType = z.infer<typeof LogoFileMimeType>;
